export default __webpack_public_path__ + "8e515ec.png";